<!-- 

	Was macht diese Componente?
	Wofür ist die Compoente da?
	
	Welche $props gibt es?
	
	Beispiel Code:
		<Dummy></Dummy>
	
	2019-06-08	init

-->

<template>
	<div class="CvSidebar background background--white sticky" :class="elmClasses">		
		<div class="CvSidebar__inner">
			<div class="CvSidebar__header hSpace hSpace--medium">
				<div class="CvSidebar__headerLink block" @click="app.reset()">
					Baden-Württemberg<br />
					Landesamt für Denkmalpflege
					<span class="CvSidebar__headerLogo block"></span>
				</div>
				<div class="CvSidebar__hr background background--middleGrey"></div>				
			</div>
			<div class="CvSidebar__body hSpace hSpace--medium">
				
				<!-- download buttons -->
				<template v-if="app.isReadyToDownload">
					<div class="CvSidebar__download vSpace vSpace--medium">
						<div class="CvSidebar__downloadText">
							<div class="color color--darkGreen font font--bold">Download</div>
							<div class="color XXcolor--darkGreen font font--sizeSmall">
								<br/>
								Es wurden alle Felder erfolgreich korrigiert.
								Die Daten können nun heruntergeladen werden.
								<br/>
								<br/>
							</div>
							<BaseButton
								class="BaseButton--downloadBtn CvSidebar__downloadBtn"
								tag="a"
								label="Download als CSV Tabelle"
								@click.native="app.doDownloadCsv()"
							></BaseButton>
							<BaseButton
								class="BaseButton--downloadBtn CvSidebar__downloadBtn"
								tag="a"
								label="Download als PDF Tabelle"
								@click.native="app.doDownloadPdf('asTable')"
							></BaseButton>
							<BaseButton
								class="BaseButton--downloadBtn CvSidebar__downloadBtn"
								tag="a"
								label="Download als PDF Datenblatt"
								@click.native="app.doDownloadPdf('asDatasets')"
							></BaseButton>
						</div>					
					</div>
				</template>
				<!-- validierungs status -->
				<template v-else-if="app.gui.view == 'CvSheet'">
					<div class="CvSidebar__progress vSpace vSpace--medium">
						<div class="CvSidebar__progressText">
							<div class="color color--grey">Zu bearbeitende Felder</div>
							<div class="color font XXfont--bold font--sizeBig"
							     :class="{
									 'color--darkRed'   : (app.outputData.countErrors > 0),
									 'color--darkGreen' : (app.outputData.countErrors < 1),
								 }">
								{{app.outputData.countErrors}}
							</div>
						</div>
						<div class="CvSidebar__progressBar">
							<div class="CvSidebar__progressBarDone"></div>
							<div class="CvSidebar__progressBarTodo" :style="progressBarTodoStyles"></div>
						</div>
					</div>
					<div class="CvSidebar__selectedScheme vSpace vSpace--medium">
						<div class="CvSidebar__hr background background--middleGrey"></div>
						<br />
						<div class="CvSidebar__selectedSchemeText">
							<div class="color color--grey">Verwendetes Schema</div>
						</div>
						<BaseSelect
							:value="app.selectedScheme"
							:label="'Bitte Schema wählen ...'"
							:options="_.map( this.app.schemes, (k, v)=>{ return v } )"
							@input="app.selectedScheme = $event"
							XXXchange="app.selectedScheme = $event.target.value"
						></BaseSelect>					
					</div>
					<div class="CvSidebar__selectedDataset vSpace vSpace--medium">
						<div class="CvSidebar__hr background background--middleGrey"></div>
						<br />
						<div class="CvSidebar__selectedSchemeText">
							<div class="color color--grey">Aktiver Datensatz</div>
						</div>
						<BaseSelect
							:value="app.currentDatasetIndex+1"
							:options="_.map( this.app.outputData.bodyRows, (k, v)=>{ return v+1 } )"
							@input="changeCurrentDatasetIndex( $event-1 )"
						></BaseSelect>
					</div>
					<div class="CvSidebar__filters vSpace vSpace--medium" v-if="app.outputData.countErrors">
						<div class="CvSidebar__hr background background--middleGrey"></div>
						<br />
						<label class="CvSidebar__filtersText">
							<div class="color color--grey">Zeige nur Probleme</div>
							<div class="flex flex--middle">
								<input type="checkbox" v-model="app.showErrorsOnly" /> &nbsp;
							</div>
						</label>					
						<br />
					</div>
					<div class="CvSidebar__hr background background--middleGrey"></div>				
						<br />
						<a @click="app.showTableModal = true">Tabellenansicht</a>
				</template>
				
				<div class="CvSidebar__debug" v-if="app.isDevEnv">
					<a @click="app.gui.view = 'CvIntro'">CvIntro</a><br/>
					<a @click="app.gui.view = 'CvSheet'">CvSheet</a><br/>					
					<hr/>
					<hr/>
					<BaseSelect
						:value="app.selectedScheme"
						:label="'Bitte Schema wählen ...'"
						:options="_.map( this.app.schemes, (k, v)=>{ return v } )"
						@input="app.selectedScheme = $event"
						XXXchange="app.selectedScheme = $event.target.value"
					></BaseSelect>					
					<hr/>					
					<pre name="currentFilename">{{app.currentFilename}}</pre>
					<!--<pre name="choosenCsvFile.name">{{_.get(app, 'choosenCsvFile.name', 'undefined')}}</pre>-->
					<pre name="selectedScheme">{{_.get(app, 'selectedScheme', 'undefined')}}</pre>
					<pre name="isReadyToValidate">{{_.get(app, 'isReadyToValidate', false)}}</pre>
					<pre name="currentCharset">{{_.get(app, 'currentCharset', false)}}</pre>
					<pre name="...countErrors">{{_.get(app, 'outputData.countErrors')}}</pre>
					<pre name="...countValidatedCells">{{_.get(app, 'outputData.countCells')}}</pre>
					<pre name="...showErrorsOnly">{{_.get(app, 'showErrorsOnly')}}</pre>
					<pre name="app.gui.view">{{app.gui.view}}</pre>
					
					<div v-for="(url, i) in app.dev.testCsvFiles" :key="i">					
						<hr/>
						<a class="breakWord" @click="app.doParseCsv( app.currentHost + url )">{{url.replace(/^.*[\\\/]/, '')}}</a>
					</div>
				</div>

			</div>
			<div class="CvSidebar__footer hSpace hSpace--medium">
				
				<div class="CvSidebar__hr background background--middleGrey"></div>
				<div class="CvSidebar__footerInner">
					<a class="CvSidebar__footerLink" @click="app.showHelpModal = true">Hilfe</a>
					<a class="CvSidebar__footerLink" @click="app.showImprintModal = true">Impressum</a>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import { EventBus } from '@/event-bus.js'
	import BaseButton from '@/components/MhForm/v1/BaseButton.vue'	
	import BaseSelect from '@/components/MhForm/v1/BaseSelect.vue'
	import CvSelect from '@/components/CvSelect.vue'

	export default {
		name: 'CvSidebar',
		components: {
			BaseSelect,
			BaseButton,
			CvSelect,
		},
		mixins: [],
		props: {},
		data() {
			return {}
		},
		watch: {},
		computed: {
			app() {
				return this.$root.$children[0]
			},
			elmClasses(){
				let classes = []
				
				//classes.push('new_class')
				
				return classes
			},
			progressBarTodoStyles(){
				let styles = {}
				
				const width = (this.app.outputData.countErrors / this.app.outputData.countCells) * 100
				
				if( this._.isNumber( width ) ) styles.width = width + '%'
				
				return styles
			}
		},
		methods: {
			changeCurrentDatasetIndex( newIndex ){
				EventBus.$emit('changeCurrentDatasetIndex', newIndex)
			},
			trashDebugFn( some ){
				console.log('trashDebugFn', some);
			},
		},
		created() {},
		mounted() {
			//let mario = this._.map( this.app.schemes, (k, v)=>{ return v } )			
			//console.log('mario:', mario)
		},
		destroyed () {},
	}
</script>

<style lang="less">
	@import "../less/vars.less";
	@import (reference) "../less/mixins.less";
	@import (reference) "../less/atoms.less";
	
	.CvSidebar {
		.relative;
		//.outline( red );
		
		max-height: 100vh;		
		max-width: 100%;
		min-width: 0;
		box-shadow: 0 0 1em 0.5em fade(black, 10);
	}
	.CvSidebar__inner {
		//& > * { outline: 1px solid red; }
		
		display: flex;
		flex-direction: column;
		height: 100vh;
	}
	.CvSidebar__header {
		position: relative;
		flex-shrink: 0;
		
		&Link {
			//outline: 1px solid red;
			position: relative;
			padding-bottom: 25%;
			color: transparent;
			margin: 2em 0;
			cursor: pointer;
		}
		&Logo {
			position: absolute;
			top: 0; left: 0; right: 0; bottom: 0;
			background-image: url('../assets/images/logo.png');
			background-repeat: no-repeat;
			background-position: top center;
			background-size: contain;
		}
	}
	.CvSidebar__body {
		flex-grow: 1;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.CvSidebar__footer {
		position: relative;
		flex-shrink: 0;
		
		&Inner {
			display: flex;
			justify-content: center;			
		}
		
		&Link {
			padding: 1.5em 1em;
			color: inherit;
			text-decoration: none;
			transition: all 0.1s ease;
			opacity: 0.5;
		}
		&Link:hover {
			opacity: 0.85;
		}
	}
	.CvSidebar__hr {
		height: 1px;
	}
	
	.CvSidebar__downloadBtn {
		margin-bottom: 0.5em;
	}
	
	.CvSidebar__debug {
		[showBorders1] & { display: block; }
		display: none;
		background-color: fade( yellow, 50 );
		padding: 0.5em;
		margin-top: 1em;
	}
	
	.CvSidebar__progress {
		&Text {
			display: flex;
			justify-content: space-between;
			padding-bottom: 0.5em;
		}
		
		&Bar {
			display: flex;
			height: 0.8em;
			border-radius: 0.3em;
			overflow: hidden;
			background-color: fade( @swatches[darkRed], 70 );
		}
		&BarDone {
			height: inherit;
			flex-grow: 1;
			
			transition: all 0.1s ease;
			border: 1px solid @swatches[green];
			border-top-left-radius: inherit;
			border-bottom-left-radius: inherit;
			border-top-right-radius: inherit;
			border-bottom-right-radius: inherit;
			background-color: @swatches[lightGreen];
		}
		&BarTodo {
			height: inherit;
			
			transition: all 0.1s ease;
			/*
			border: 1px solid @swatches[red];			
			margin-right: -3px;
			border-top-right-radius: inherit;
			border-bottom-right-radius: inherit;
			background-color: @swatches[lightRed];
			*/
		}
	}
	.CvSidebar__selectedScheme {
		&Text {
			display: flex;
			justify-content: space-between;
			padding-bottom: 0.5em;
		}
	}
	.CvSidebar__filters {
		&Text {
			display: flex;
			justify-content: space-between;
			padding-bottom: 0.5em;
			align-items: flex-start;
			//line-height: 1em;
		}
		
		&InputWrapper {
			display: block;			
		}
	}
	
	@media @mediaQueries[xs] {}
	@media @mediaQueries[sm] {}
	@media @mediaQueries[md] {}
	@media @mediaQueries[dt] {}
	@media @mediaQueries[lg] {}
	@media @mediaQueries[xl] {}
</style>
